angular.module('impactx.fallbackstartpage').controller('FallBackStartPageCtrl', [
    '$workspace',
    '$redirect',
    '$securityManager',
    '$scope',
    '$context',
    'searchFilter',
    'SearchFilter',
    FallBackStartPageCtrl]);

function FallBackStartPageCtrl($workspace, $redirect, $securityManager, $scope, $context, searchFilter, SearchFilter) {
    $scope.$watch(function() {
        return $context.showSearch.value
    }, function(newVal, oldValue) {
        if(newVal && !oldValue) {
            searchFilter.resetSearchFilter().then(function() {
                searchFilter.searchInput = '';
                searchFilter.searchInputGlobal = '';
                SearchFilter.resetSearch();
                $scope.fixedFilters = searchFilter.getSearchFilterData();
            });
        }
    });
    $securityManager.isProcessAllowedWatch($scope, "Search", function(isAllowed) {
        if(isAllowed) {
            searchFilter.resetSearchFilter().then(function() {
                searchFilter.searchInput = '';
                searchFilter.searchInputGlobal = '';
                SearchFilter.resetSearch();
            });
        }
    });

    $redirect.redirectTo(null, $workspace.getStartPage())
}